import ContentHeader from 'components/ContentHeader';
import { FastFacts } from 'components/FastFacts/FastFacts';

import { useFeatureFlag } from 'hooks/useFeatureFlag';

import i18n from 'i18n-react';

export function FastFactsView() {
  const isAmbassador = useFeatureFlag('ambassador');

  const headerText = isAmbassador ? i18n.translate('ambassador.nav.promote') : i18n.translate('nav.promote');

  return (
    <div className="contentContainer fast-facts-view" data-testid="fast-facts-view">
      <ContentHeader
        header={headerText}
        subtitle={i18n.translate(isAmbassador ? 'pageDescriptions.promoteAmbassador' : 'pageDescriptions.promote')}
        social
        line
      />
      <FastFacts />
    </div>
  );
}
